// extracted by mini-css-extract-plugin
export default {"body-row":"body-row_body-row__6g8QT","body-row--with-pointer":"body-row_body-row--with-pointer__-9ucO"};